import axios from "axios";

import { DASHBOARD_STORAGE_KEYS } from "../accessControl";

const DEFAULT_LOGIN_RETRIES = 5;

const getStoredBackendUserId = () => {
  const rawUser = localStorage.getItem(DASHBOARD_STORAGE_KEYS.user);

  if (!rawUser) {
    return null;
  }

  try {
    const parsedUser = JSON.parse(rawUser);
    return parsedUser?.id ?? 1;
  } catch (error) {
    console.error("Error reading backend user from localStorage:", error);
    return null;
  }
};

const persistAdminSession = (backendUser, authUser) => {
  const userData = {
    id: backendUser.id,
    first_name: backendUser.first_name,
    last_name: backendUser.last_name,
    email: backendUser.email,
    role_id: backendUser.role_id,
  };

  localStorage.setItem(DASHBOARD_STORAGE_KEYS.user, JSON.stringify(userData));
  sessionStorage.setItem(DASHBOARD_STORAGE_KEYS.token, backendUser.token);
  sessionStorage.setItem(
    DASHBOARD_STORAGE_KEYS.tokenExpire,
    backendUser.tokenExpiration,
  );
  localStorage.setItem(DASHBOARD_STORAGE_KEYS.username, authUser.nickname);
  localStorage.setItem(DASHBOARD_STORAGE_KEYS.photo, authUser.picture);
};

export const loginAdminUser = async (
  authUser,
  navigate,
  retries = DEFAULT_LOGIN_RETRIES,
) => {
  if (!authUser?.email) {
    return false;
  }

  const data = {
    email: authUser.email,
    key: process.env.REACT_APP_KEY,
  };

  for (let attempt = 1; attempt <= retries; attempt += 1) {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/users/login`,
        data,
      );

      if (response.data.code === 1) {
        persistAdminSession(response.data.user, authUser);
        return true;
      }
    } catch (error) {
      if (attempt === retries) {
        console.error("Error logging user into backend:", error);
      }
      navigate("/dashboard/login");
    }
  }

  return false;
};

export const fetchAdminPermissions = async () => {
  const backendUserId = getStoredBackendUserId();

  if (!backendUserId) {
    throw new Error("No backend user id available to fetch permissions.");
  }

  const permissionsRes = await axios.get(
    `${process.env.REACT_APP_URL_BACKEND}/api/v1/permissions/${backendUserId}`,
    {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem(DASHBOARD_STORAGE_KEYS.token)}`,
      },
    },
  );

  const permissions = permissionsRes?.data?.data ?? [];

  localStorage.setItem(
    DASHBOARD_STORAGE_KEYS.permissions,
    JSON.stringify(permissions),
  );

  return permissions;
};
